import type { FaireProductEntity } from "../../entity_types/product";

export const p_9qtv3vuth7: FaireProductEntity = {
  token: "p_9qtv3vuth7",
  type: "product",
  name: "I Like Plants More Than People Gym Crew Socks",
  brandToken: "b_1fc44661",
  brandName: "Gumball Poodle",
  imageUrl: "https://cdn.faire.com/fastly/8f34ac45dcc2f1bfd53d8682748b4d6b20382b93fbf5035f5f0dd7d4e0ad4889.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/5efb223adb1828436029f8f8bd929ef229b43b0a393205f19793c83a241c1994.jpeg",
    "https://cdn.faire.com/fastly/4c89e486fb02f97b6627f02fb8bd20ba5268ea9da7ce3c2f088a1054112abddb.jpeg",
    "https://cdn.faire.com/fastly/e905299ebf60a9a716c18bd0d111c686e98f2685ae50ec17f954482488815cd4.jpeg",
    "https://cdn.faire.com/fastly/65f97c14ddab1380168ef6503265a88710d3dd3fe28534ef1e853b8834b55a34.jpeg",
    "https://cdn.faire.com/fastly/399b1254d31ce5a908793fb2bb55a201a56d5206e69fd59f4182250d68f9b1b0.jpeg",
    "https://cdn.faire.com/fastly/f66e6b1a5ec25455363b579d3804ce8da336ec518f1ec59ca1d068f27877e3e5.jpeg",
    "https://cdn.faire.com/fastly/4b413feadcc2946e269ba89bcc489db1ef5f4fa90d25fd592727d3bda48350a9.jpeg"
  ],
  priceDollars: 6.75,
  description: "Comfy socks for the proud plant parent who prefers propagation over participation. 🌱\n\nGumball Poodle is GPSR compliant! We will automatically be stickering all orders into the EU or Northern Ireland for GPSR compliance.\n\nIf you are in the UK but sell into the EU, we can provide you with the necessary stickers to put on products - be sure to tell us you need these when you place your order.",
  tags: [],
  msrpDollars: 14,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-12T05:33:25.303Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
